/** Interface language for fixed product copy. */
export type UiLocale = "zh-CN" | "en-US";

export const DEFAULT_UI_LOCALE: UiLocale = "zh-CN";

export function isUiLocale(value: unknown): value is UiLocale {
  return value === "zh-CN" || value === "en-US";
}

export function toResponseLanguage(locale: UiLocale): "zh" | "en" {
  return locale === "en-US" ? "en" : "zh";
}
